<template>
    <v-container>
      <v-overlay :value="loading" z-index="9999">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>
      <div>
        <s-crud
          :config="config"
          add
          search-input
          title="Periodos Cerrados"
          ref="PeriodsCrud"
          @save="save()"
          height="auto"
        >

          <template scope="props">
            <v-row justify="center">
              <v-col cols="12" lg="2" md="6">
                <s-select label="Año" :items="years" outlined hide-details dense v-model="year"></s-select>
              </v-col>
              <v-col cols="12" lg="2" md="6">
                <s-select label="Mes" :items="itemsMonth" outlined hide-details dense v-model="month"></s-select>
              </v-col>
              <v-col cols="12" lg="2" md="6">
                <s-date label="Fecha Inicio" v-model='item.BeginDate'/>
              </v-col>
              <v-col cols="12" lg="2" md="6"> 
                <s-date label="Fecha Fin" v-model='item.EndDate'></s-date>
              </v-col>
            </v-row>
          </template>

        </s-crud>
      </div>
    </v-container>
</template>

<script>

import _sClosePeriodService from "@/services/Accounting/AccoutingPeriodsService";

export default {
  name: "",
  props: {},
  data: () => ({
    filter: {},
    item: {},
    years: null,
    year: null,
    itemsMonth: null,
    month: null,
    week: null,
    loading: false,
    config: {
      model: {
        CprID: "ID",
        CprBeginDate: "date",
        CprEndDate: "date",
        CprProcessDate: "datetime"
      },
      service: _sClosePeriodService,
      headers: [
        { text: "ID", value: "CprID", sortable: false, width: 10 },
        { text: "Año", value: "CprYear", sortable: false },
        { text: "Mes", value: "CprMonthName", sortable: false },
        { text: "Fecha Inicio", value: "CprBeginDate", sortable: false },
        { text: "Fecha Fin", value: "CprEndDate", sortable: false },
        { text: "Registros Procesados", value: "CprRecordsProcessed", sortable: false },
        { text: "Fecha Procesado", value: "CprProcessDate", sortable: false },
      ],
    }
  }),
  methods: {
    selection() {
      if(this.month != null){
        let dd = 19;
        let m = this.month - 1;
        if (m < 1)
            this.item.BeginDate = this.$moment(this.year - 1 + "1220").format(
                "YYYY-MM-DD"
            );
        else {
            let mo = m <= 9 ? "0" + m : m;
            this.item.BeginDate = this.$moment(
                    this.year.toString() + mo.toString() + "01"
                )
                .add(dd, "days")
                .format("YYYY-MM-DD");
        }

        let d = 18;
        this.item.EndDate = this.$moment(
                this.year.toString() +
                "" +
                (this.month <= 9 ? "0" + this.month.toString() : this.month) +
                "01"
            )
            .add(d, "days")
            .format("YYYY-MM-DD");
      }
    },
    save() {
      this.item.CjnYear = this.year;
      this.item.CjnMonth = this.month;
      this.item.UsrCreateID = this.$fun.getUserID();
      console.log("this.items", this.item);

      this.$fun.alert("¿Seguro de guardar?", "question")
				.then(r => {
					if(r.value){
          this.loading = true;
          _sClosePeriodService.save(this.item, this.$fun.getUserID())
            .then(() => {
              this.loading = false;
              this.$refs.PeriodsCrud.refresh();
            })
            .catch(() => {
              this.loading = false;
              this.$refs.PeriodsCrud.refresh();
            });
          }
        }
      );
    },
  },
  watch: {
    month() {
      this.selection();
    },
    week() {
      this.item.BeginDate = this.week.PdsDateBegin;
      this.item.EndDate = this.week.PdsDateEnd;
    },
    year() {
      this.week = [];
    }
  },
  created() {
    this.itemsMonth = this.$const.Months;
    this.years = this.$fun.getTop5LastYears();
    this.year = this.$moment().year();
  }
};
</script>